document.addEventListener('alpine:init', () => {
    // Used on bio/shows pages — thumbnails only, modal always opens, lazy bc() video init
    Alpine.data('bioGallery', () => ({
        arrayOfAssets: JSON.parse(document.getElementById('gallery-assets').textContent),
        modalOpen: false,
        assetData: {},
        myPlayer: null,
        showBodyContent: true,

        init() {
            if (this.arrayOfAssets.length > 0) {
                this.activeMediaItem(this.arrayOfAssets[0].id);
            }
            if (this.$refs.content) {
                this.$nextTick(() => {
                    this.showBodyContent = this.$refs.content.innerText.trim().length > 0;
                });
            }
            this.$watch('modalOpen', (open) => {
                if (open) {
                    // Blur the focused thumbnail before x-trap sets aria-hidden on #app,
                    // otherwise the browser blocks aria-hidden on an ancestor of a focused element.
                    document.activeElement?.blur();
                }
            });
        },

        activeMediaItem(id) {
            let data = this.arrayOfAssets.find(item => item.id === id);
            this.assetData = data;
            if (data.type == 'video') {
                this.playVideoInline(this.assetData.brightcoveId);
            } else {
                this.pauseVideo();
            }
        },

        // bc() lazy init is intentional — x-teleport moves the video element in the DOM
        // before Brightcove can pre-initialize it, so we initialize on first play instead.
        playVideoInline(vidId) {
            if (this.myPlayer) {
                this.myPlayer.catalog.getVideo(vidId, (error, video) => {
                    this.myPlayer.catalog.load(video);
                    this.myPlayer.play();
                });
            } else {
                let vTag = document.querySelector('#video-player video');
                if (!vTag) return;
                vTag.setAttribute('data-account', '24489591001');
                vTag.setAttribute('data-player', 'kbalFD0Y3Z');
                vTag.setAttribute('data-video-id', vidId);
                this.myPlayer = bc(vTag);
                this.myPlayer.on('loadedmetadata', () => this.myPlayer.play());
            }
        },

        pauseVideo() {
            if (this.myPlayer) this.myPlayer.pause();
        },

        touchStartX: null,

        swipeStart(e) {
            this.touchStartX = e.touches[0].clientX;
        },

        swipeEnd(e) {
            if (this.touchStartX === null) return;
            const dx = e.changedTouches[0].clientX - this.touchStartX;
            this.touchStartX = null;
            if (Math.abs(dx) < 50) return;
            this.activeMediaItem(dx < 0 ? this.assetData.nextId : this.assetData.prevId);
        },

        swipeCancel() {
            this.touchStartX = null;
        },
    }));

    // Used on the dedicated media gallery page — desktop inline view + mobile modal
    Alpine.data('mediaGallery', () => ({
        arrayOfAssets: JSON.parse(document.getElementById('gallery-assets').textContent),
        modalOpen: false,
        assetData: {},

        init() {
            const photoid = new URLSearchParams(window.location.search).get('photoid');
            const startAsset = photoid
                ? this.arrayOfAssets.find(a => a.path === photoid)
                : null;
            this.activeMediaItem((startAsset ?? this.arrayOfAssets[0]).id);
        },

        activeMediaItem(id) {
            let data = this.arrayOfAssets.find(item => item.id === id);
            this.assetData = data;
            if (data.path) {
                const url = new URL(window.location.href);
                url.searchParams.set('photoid', data.path);
                history.replaceState(null, '', url.toString());
                if (typeof window._sz !== 'undefined') {
                    window._sz.push(['trackPageview', url.toString()]);
                }
            }
            if (data.type == 'video') {
                this.playVideoInline(this.assetData.brightcoveId);
            } else {
                this.pauseVideo();
            }
        },

        playVideoInline(vidId) {
            let playerId = this.modalOpen ? '#v1_html5_api' : '#1_html5_api';
            let player = videojs.getPlayer(playerId);
            if (!player) return;
            player.ready(function () {
                var myPlayer = this;
                myPlayer.catalog.getVideo(vidId, function (error, video) {
                    myPlayer.catalog.load(video);
                    myPlayer.play();
                });
            });
        },

        pauseVideo() {
            let player = videojs.getPlayer('#1_html5_api');
            if (player) player.pause();
            let modalPlayer = videojs.getPlayer('#v1_html5_api');
            if (modalPlayer) modalPlayer.pause();
        },
    }));
});
